
import { defineComponent, PropType } from "vue";
import { Ingrediente } from "@/api/interfacesReceita";
export default defineComponent({
  Name: "TabelaIngredientes",
  props: {
    ingredientesReceita: {
      type: Array as PropType<Ingrediente[]>,
      required: false
    }
  },
  setup(props) {
    return { props };
  }
});
